import ds, {dsc, ___} from '../utils/daoService/DaoServiceClientES6Adapter'

const ebParty = ds.QEbParty.using(dsc)

// 通过ebOrderId查询
ebParty.getEbPartyByEbOrderId = function (ebOrderId) {
  return ebParty
    .select(ebParty.fieldContainer())
    .where(ebParty.ebOrderId.eq$(ebOrderId))
    .tag('getEbPartyByEbOrderId')
    .execute()
}
export default ebParty
